// based on https://github.com/unicode-org/cldr/blob/release-36/common/supplemental/supplementalData.xml#L4676-L4726
// locales are in the format 'language-region' where language and region are both 2-letter abbreviations.
// ex: 'en-US' stands for English (en) as spoken in the United States (US).
// the following list is a list of possible values for region, associated with their first day of the week on calendars.
// Many have Sunday as the first day, some Monday, some Saturday...
export default {
  sun: [
    'AG',
    'AS',
    'AU',
    'BD',
    'BR',
    'BS',
    'BT',
    'BW',
    'BZ',
    'CA',
    'CN',
    'CO',
    'DM',
    'DO',
    'ET',
    'GT',
    'GU',
    'HK',
    'HN',
    'ID',
    'IL',
    'IN',
    'JM',
    'JP',
    'KE',
    'KH',
    'KR',
    'LA',
    'MH',
    'MM',
    'MO',
    'MT',
    'MX',
    'MZ',
    'NI',
    'NP',
    'PA',
    'PE',
    'PH',
    'PK',
    'PR',
    'PT',
    'PY',
    'SA',
    'SG',
    'SV',
    'TH',
    'TT',
    'TW',
    'UM',
    'US',
    'VE',
    'VI',
    'WS',
    'YE',
    'ZA',
    'ZW'
  ],
  mon: [
    '001',
    '419',
    'AD',
    'AI',
    'AL',
    'AM',
    'AN',
    'AR',
    'AT',
    'AX',
    'AZ',
    'BA',
    'BE',
    'BG',
    'BM',
    'BN',
    'BY',
    'CH',
    'CL',
    'CM',
    'CR',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EC',
    'EE',
    'ES',
    'FI',
    'FJ',
    'FO',
    'FR',
    'GB',
    'GE',
    'GF',
    'GP',
    'GR',
    'HR',
    'HU',
    'IE',
    'IS',
    'IT',
    'KG',
    'KZ',
    'LB',
    'LI',
    'LK',
    'LT',
    'LU',
    'LV',
    'MC',
    'MD',
    'ME',
    'MK',
    'MN',
    'MQ',
    'MY',
    'NL',
    'NO',
    'NZ',
    'PL',
    'RE',
    'RO',
    'RS',
    'RU',
    'SE',
    'SI',
    'SK',
    'SM',
    'TJ',
    'TM',
    'TR',
    'UA',
    'UY',
    'UZ',
    'VA',
    'VN',
    'XK'
  ],
  sat: [
    'AE',
    'AF',
    'BH',
    'DJ',
    'DZ',
    'EG',
    'IQ',
    'IR',
    'JO',
    'KW',
    'LY',
    'OM',
    'QA',
    'SD',
    'SY'
  ]
};
